import React from "react";

import {ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {hitGTMOfferSelectItem} from "../tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    sourceSection?: ApplicationSourceSection;
    mainPage?: boolean;
    shouldLinkToOffer?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    gtmMeta: IOfferBox["gtmMeta"];
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {unlinkVendor, mainPage} = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        hitGTMOfferSelectItem({
            offer,
            listId: props.gtmMeta.listId,
            listName: props.gtmMeta.listName
        });
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery: props.latestQuery,
            gtmSource: props.gtmMeta.source
        });
    };

    return (
        <OfferBox
            offer={props.offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={props.offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            disableFavInfoText={mainPage}
            shouldLinkToOffer={props.shouldLinkToOffer}
            onClick={props.onClick}
            index={props.index}
            titleTag={props.titleTag}
            gtmMeta={props.gtmMeta}
            latestQuery={props.latestQuery}
            dataTestId={props.dataTestId}
        />
    );
}
import React from "react";

import {ApplicationSourceSection} from "../../application/utils/form/application_form_source";
import {ILatestQuery} from "../../utils/latest_query";
import {IOfferBox, OfferBox} from "../components/offer_box/OfferBox";
import {useOfferDetailsActions} from "../hooks/use_offer_details_actions";
import {IModalPropertyListOffer} from "../list/components/OfferListPropertiesModal";
import {hitGTMOfferSelectItem} from "../tracking/ecommerce_events/offer/hit_gtm_offer_select_item";
import {IOfferBoxOffer} from "../types/IOfferBoxOffer";
import {IOfferModalOffer} from "../types/OfferModalOffer";

interface IProps {
    dataTestId?: string;
    offer: IOfferBoxWithPropertiesModalOffer;
    unlinkVendor?: boolean;
    sourceSection?: ApplicationSourceSection;
    mainPage?: boolean;
    shouldLinkToOffer?: boolean;
    onClick?: () => void;
    index: number;
    titleTag?: React.ElementType;
    latestQuery?: ILatestQuery & Record<string, string | string[] | null>;
    gtmMeta: IOfferBox["gtmMeta"];
}

export type IOfferBoxWithPropertiesModalOffer = IOfferBoxOffer & IModalPropertyListOffer;

export function OfferBoxWithOfferDetailsAction(props: IProps) {
    const {unlinkVendor, mainPage} = props;

    const {showOfferDetailsGeneralHandler} = useOfferDetailsActions();

    const handleShowOfferDetailsBtnClick = (offer: IOfferModalOffer) => {
        hitGTMOfferSelectItem({
            offer,
            listId: props.gtmMeta.listId,
            listName: props.gtmMeta.listName
        });
        showOfferDetailsGeneralHandler({
            offer,
            latestQuery: props.latestQuery,
            gtmSource: props.gtmMeta.source
        });
    };

    return (
        <OfferBox
            offer={props.offer}
            onShowOfferDetailsBtnClick={handleShowOfferDetailsBtnClick}
            offerDetailsBtnText={props.offer.configuration.pre_sale ? "Zobacz inwestycję" : undefined}
            unlinkVendor={unlinkVendor}
            disableFavInfoText={mainPage}
            shouldLinkToOffer={props.shouldLinkToOffer}
            onClick={props.onClick}
            index={props.index}
            titleTag={props.titleTag}
            gtmMeta={props.gtmMeta}
            latestQuery={props.latestQuery}
            dataTestId={props.dataTestId}
        />
    );
}
